<attrs/iframeAttrs/>

<iframe/first ...iframeAttrs/>
<iframe/second ...iframeAttrs style="display:none"/>

<return={
  next() {
    const firstHidden = first().style.display === "none";
    return firstHidden ? first() : second();
  },
  swap() {
    const firstHidden = first().style.display === "none";
    const current = firstHidden ? second() : first();
    const next = firstHidden ? first() : second();
    current.srcdoc = current.srcdoc;
    current.style.display = "none";
    next.style.display = "";
    return next;
  }
}/>